import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "svg-icon-TickShape",
  "use": "svg-icon-TickShape-usage",
  "viewBox": "-1 -3 16 16",
  "content": "<symbol viewBox=\"-1 -3 16 16\" xmlns=\"http://www.w3.org/2000/svg\" id=\"svg-icon-TickShape\"><path d=\"M5.119 7.83L1.354 3.78 0 5.017 5.095 10.5 14 1.261 12.67 0z\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol